/**
 * Component - v2.1.0
 */

import React from 'react';

// Supermove
import {PageContext} from '@supermove/analytics';
import {useActiveRoute, useTrackPageview} from '@supermove/hooks';
import {CodePush} from '@supermove/sdk';

const RouterWrapper = ({navigation, children}: any) => {
  const {route} = useActiveRoute({navigation});
  // @ts-expect-error TS(2339): Property 'routeName' does not exist on type 'Navig... Remove this comment to see the full error message
  const {routeName} = route;
  useTrackPageview({routeName});
  return <PageContext.Provider value={{pageName: routeName}}>{children}</PageContext.Provider>;
};

const options = {
  // We check manually on the Start page when the app is started.
  checkFrequency: CodePush.CheckFrequency.MANUAL,
};

export default CodePush(options)(RouterWrapper);
